module.exports = __webpack_public_path__ + "img/0_1.eef1f4bb.png";